var map = {
	"./apryse-logo.svg": 692,
	"./calibrate.svg": 693,
	"./digital_signature_empty.svg": 694,
	"./digital_signature_error.svg": 695,
	"./digital_signature_valid.svg": 696,
	"./digital_signature_warning.svg": 697,
	"./function.svg": 698,
	"./group-annotations-icon.svg": 699,
	"./ic-accounting.svg": 700,
	"./ic-align-bottom-ios.svg": 701,
	"./ic-align-middle-ios.svg": 702,
	"./ic-align-top-ios.svg": 703,
	"./ic-alignment-bottom.svg": 704,
	"./ic-alignment-center-horizontal.svg": 705,
	"./ic-alignment-center-vertical.svg": 706,
	"./ic-alignment-left.svg": 707,
	"./ic-alignment-main.svg": 708,
	"./ic-alignment-right.svg": 709,
	"./ic-alignment-top.svg": 710,
	"./ic-audio-redact.svg": 711,
	"./ic-automatic.svg": 712,
	"./ic-bookmark.svg": 713,
	"./ic-border-all.svg": 714,
	"./ic-border-bottom.svg": 715,
	"./ic-border-color.svg": 716,
	"./ic-border-horizontal.svg": 717,
	"./ic-border-inside.svg": 718,
	"./ic-border-left.svg": 719,
	"./ic-border-main.svg": 720,
	"./ic-border-none.svg": 721,
	"./ic-border-outside.svg": 722,
	"./ic-border-right.svg": 723,
	"./ic-border-top.svg": 724,
	"./ic-border-vertical.svg": 725,
	"./ic-calculator.svg": 726,
	"./ic-calendar-time.svg": 727,
	"./ic-calendar.svg": 728,
	"./ic-calibrate.svg": 729,
	"./ic-clock-hour.svg": 730,
	"./ic-copy-color.svg": 731,
	"./ic-currency.svg": 732,
	"./ic-decrease-decimal.svg": 733,
	"./ic-delete-column-shift-left.svg": 734,
	"./ic-delete-column-shift-up.svg": 735,
	"./ic-delete-column.svg": 736,
	"./ic-delete-page.svg": 737,
	"./ic-delete-row.svg": 738,
	"./ic-delete.svg": 739,
	"./ic-distribute-horizontal.svg": 740,
	"./ic-distribute-vertical.svg": 741,
	"./ic-dollar-circle-rounded.svg": 742,
	"./ic-dollar-circle.svg": 743,
	"./ic-edit-page.svg": 744,
	"./ic-file-cad.svg": 745,
	"./ic-file-doc.svg": 746,
	"./ic-file-etc.svg": 747,
	"./ic-file-img.svg": 748,
	"./ic-file-pdf.svg": 749,
	"./ic-file-ppt.svg": 750,
	"./ic-file-xls.svg": 751,
	"./ic-fill-and-sign.svg": 752,
	"./ic-fill.svg": 753,
	"./ic-filter-alt.svg": 754,
	"./ic-filter-with-dot.svg": 755,
	"./ic-folder-open.svg": 756,
	"./ic-full-frame-video-and-audio-redact.svg": 757,
	"./ic-full-frame-video-redact.svg": 758,
	"./ic-hamburger-menu.svg": 759,
	"./ic-increase-decimal.svg": 760,
	"./ic-indent-decrease.svg": 761,
	"./ic-indent-increase.svg": 762,
	"./ic-insert text.svg": 763,
	"./ic-insert-column-left.svg": 764,
	"./ic-insert-column-right.svg": 765,
	"./ic-insert-column-shift-down.svg": 766,
	"./ic-insert-column-shift-right.svg": 767,
	"./ic-insert-column.svg": 768,
	"./ic-insert-row-bottom.svg": 769,
	"./ic-insert-row-top.svg": 770,
	"./ic-layer.svg": 771,
	"./ic-merge.svg": 772,
	"./ic-number.svg": 773,
	"./ic-paragraph.svg": 774,
	"./ic-percent.svg": 775,
	"./ic-replace text.svg": 776,
	"./ic-table.svg": 777,
	"./ic-unmerge.svg": 778,
	"./ic-wv3d-properties-panel-menu.svg": 779,
	"./ic_annotation_cloudy_rectangular_area_black_24px.svg": 780,
	"./ic_annotation_ellipse_area_black.svg": 781,
	"./ic_annotation_eraser_black_24px.svg": 782,
	"./ic_annotation_rectangular_area_black_24px.svg": 783,
	"./ic_annotation_signature_black_24px.svg": 784,
	"./ic_annotation_strikeout_black_24px.svg": 785,
	"./ic_annotation_underline_black_24px.svg": 786,
	"./ic_bookmarks_black_24px.svg": 787,
	"./ic_check_black_24px.svg": 788,
	"./ic_chevron_down_black_24px.svg": 789,
	"./ic_chevron_left_black_24px.svg": 790,
	"./ic_chevron_right_black_24px.svg": 791,
	"./ic_chevron_up_black_24px.svg": 792,
	"./ic_close_black_24px.svg": 793,
	"./ic_copy_black_24px.svg": 794,
	"./ic_crop_black_24px.svg": 795,
	"./ic_edit_page_24px.svg": 796,
	"./ic_fileattachment_24px.svg": 797,
	"./ic_layers_24px.svg": 798,
	"./ic_pause_24px.svg": 799,
	"./ic_play_24px.svg": 800,
	"./ic_replace.svg": 801,
	"./ic_select_black_24px.svg": 802,
	"./ic_snipping_black_24px.svg": 803,
	"./ic_sound_24px.svg": 804,
	"./ic_thumbnails_grid_black_24px.svg": 805,
	"./icon-accessibility-mode.svg": 806,
	"./icon-action-redo.svg": 807,
	"./icon-action-undo.svg": 808,
	"./icon-active-indicator.svg": 809,
	"./icon-add-file.svg": 810,
	"./icon-add-folder.svg": 811,
	"./icon-alert.svg": 812,
	"./icon-annotate-ribbon.svg": 813,
	"./icon-annotation-select-multiple.svg": 814,
	"./icon-annotation-status-accepted.svg": 815,
	"./icon-annotation-status-cancelled.svg": 816,
	"./icon-annotation-status-completed.svg": 817,
	"./icon-annotation-status-marked.svg": 818,
	"./icon-annotation-status-none.svg": 819,
	"./icon-annotation-status-rejected.svg": 820,
	"./icon-annotation-status-unmarked.svg": 821,
	"./icon-arrow-back.svg": 822,
	"./icon-arrow-down.svg": 823,
	"./icon-arrow-left.svg": 824,
	"./icon-arrow-right.svg": 825,
	"./icon-arrow-to-bottom.svg": 826,
	"./icon-arrow-to-middle.svg": 827,
	"./icon-arrow-to-top.svg": 828,
	"./icon-arrow-up.svg": 829,
	"./icon-chat-bubble.svg": 830,
	"./icon-chevron-down.svg": 831,
	"./icon-chevron-left.svg": 832,
	"./icon-chevron-right.svg": 833,
	"./icon-chevron-up.svg": 834,
	"./icon-close.svg": 835,
	"./icon-comments-filter.svg": 836,
	"./icon-compare-change.svg": 837,
	"./icon-compare-file-open.svg": 838,
	"./icon-content-edit.svg": 839,
	"./icon-copy.svg": 840,
	"./icon-copy2.svg": 841,
	"./icon-cut.svg": 842,
	"./icon-dark-mode-option.svg": 843,
	"./icon-delete-line.svg": 844,
	"./icon-detach-toolbar.svg": 845,
	"./icon-double-chevron-down.svg": 846,
	"./icon-download.svg": 847,
	"./icon-drag-handle.svg": 848,
	"./icon-edit-form-field.svg": 849,
	"./icon-folder.svg": 850,
	"./icon-form-field-button.svg": 851,
	"./icon-form-field-checkbox.svg": 852,
	"./icon-form-field-combobox.svg": 853,
	"./icon-form-field-listbox.svg": 854,
	"./icon-form-field-radiobutton.svg": 855,
	"./icon-form-field-signature.svg": 856,
	"./icon-form-field-text.svg": 857,
	"./icon-header-chat-line.svg": 858,
	"./icon-header-compare.svg": 859,
	"./icon-header-file-picker-line.svg": 860,
	"./icon-header-full-screen-exit.svg": 861,
	"./icon-header-full-screen.svg": 862,
	"./icon-header-page-manipulation-insert-above.svg": 863,
	"./icon-header-page-manipulation-line.svg": 864,
	"./icon-header-page-manipulation-page-layout-cover-line.svg": 865,
	"./icon-header-page-manipulation-page-layout-double-page-line.svg": 866,
	"./icon-header-page-manipulation-page-layout-single-page-line.svg": 867,
	"./icon-header-page-manipulation-page-rotation-clockwise-line.svg": 868,
	"./icon-header-page-manipulation-page-rotation-counterclockwise-line.svg": 869,
	"./icon-header-page-manipulation-page-transition-continuous-page-line.svg": 870,
	"./icon-header-page-manipulation-page-transition-page-by-page-line.svg": 871,
	"./icon-header-page-manipulation-page-transition-reader.svg": 872,
	"./icon-header-pan.svg": 873,
	"./icon-header-print-line.svg": 874,
	"./icon-header-search.svg": 875,
	"./icon-header-select-line.svg": 876,
	"./icon-header-settings-line.svg": 877,
	"./icon-header-sidebar-line.svg": 878,
	"./icon-header-zoom-fit-to-page.svg": 879,
	"./icon-header-zoom-fit-to-width.svg": 880,
	"./icon-header-zoom-in-line.svg": 881,
	"./icon-header-zoom-marquee.svg": 882,
	"./icon-header-zoom-out-line.svg": 883,
	"./icon-image-green.svg": 884,
	"./icon-index-panel-list.svg": 885,
	"./icon-info.svg": 886,
	"./icon-insert-ribbon.svg": 887,
	"./icon-keyboard.svg": 888,
	"./icon-light-mode-option.svg": 889,
	"./icon-linestyle-cloudy-line.svg": 890,
	"./icon-linestyle-dash-1-4-8-4.svg": 891,
	"./icon-linestyle-dash-2-2.svg": 892,
	"./icon-linestyle-dash-3-6-10-6.svg": 893,
	"./icon-linestyle-dash-4-4.svg": 894,
	"./icon-linestyle-dash-4-6-10-6.svg": 895,
	"./icon-linestyle-dash-6-6.svg": 896,
	"./icon-linestyle-dashed-line-wide.svg": 897,
	"./icon-linestyle-dotted-line-wide.svg": 898,
	"./icon-linestyle-end-arrow-closed-reverse.svg": 899,
	"./icon-linestyle-end-arrow-closed.svg": 900,
	"./icon-linestyle-end-arrow-open-reverse.svg": 901,
	"./icon-linestyle-end-arrow-open.svg": 902,
	"./icon-linestyle-end-butt.svg": 903,
	"./icon-linestyle-end-circle.svg": 904,
	"./icon-linestyle-end-diamond.svg": 905,
	"./icon-linestyle-end-slash.svg": 906,
	"./icon-linestyle-end-square.svg": 907,
	"./icon-linestyle-none.svg": 908,
	"./icon-linestyle-solid-line-wide.svg": 909,
	"./icon-linestyle-solid-line.svg": 910,
	"./icon-linestyle-start-arrow-closed-reverse.svg": 911,
	"./icon-linestyle-start-arrow-closed.svg": 912,
	"./icon-linestyle-start-arrow-open-reverse.svg": 913,
	"./icon-linestyle-start-arrow-open.svg": 914,
	"./icon-linestyle-start-butt.svg": 915,
	"./icon-linestyle-start-circle.svg": 916,
	"./icon-linestyle-start-diamond.svg": 917,
	"./icon-linestyle-start-slash.svg": 918,
	"./icon-linestyle-start-square.svg": 919,
	"./icon-lock-wire.svg": 920,
	"./icon-lock.svg": 921,
	"./icon-magnifying-glass.svg": 922,
	"./icon-menu-add.svg": 923,
	"./icon-menu-align-centre.svg": 924,
	"./icon-menu-align-left.svg": 925,
	"./icon-menu-align-right.svg": 926,
	"./icon-menu-bold.svg": 927,
	"./icon-menu-both-align.svg": 928,
	"./icon-menu-center-align.svg": 929,
	"./icon-menu-checkmark.svg": 930,
	"./icon-menu-italic.svg": 931,
	"./icon-menu-left-align.svg": 932,
	"./icon-menu-right-align.svg": 933,
	"./icon-menu-style-line.svg": 934,
	"./icon-menu-text-underline.svg": 935,
	"./icon-no-marked-redactions.svg": 936,
	"./icon-office-editor-bullet-list.svg": 937,
	"./icon-office-editor-circle.svg": 938,
	"./icon-office-editor-column.svg": 939,
	"./icon-office-editor-line-spacing.svg": 940,
	"./icon-office-editor-list-style-arrow.svg": 941,
	"./icon-office-editor-list-style-bullet.svg": 942,
	"./icon-office-editor-list-style-check.svg": 943,
	"./icon-office-editor-list-style-diamond.svg": 944,
	"./icon-office-editor-list-style-latin-roman.svg": 945,
	"./icon-office-editor-list-style-number-decimal.svg": 946,
	"./icon-office-editor-list-style-number-latin-1.svg": 947,
	"./icon-office-editor-list-style-number-latin-2.svg": 948,
	"./icon-office-editor-list-style-roman-latin.svg": 949,
	"./icon-office-editor-list-style-square-bullet.svg": 950,
	"./icon-office-editor-list-style-square.svg": 951,
	"./icon-office-editor-margin.svg": 952,
	"./icon-office-editor-number-list.svg": 953,
	"./icon-office-editor-page-break-split.svg": 954,
	"./icon-office-editor-page-break.svg": 955,
	"./icon-office-editor-toggle-non-printing-characters.svg": 956,
	"./icon-open-folder.svg": 957,
	"./icon-operation-eraser.svg": 958,
	"./icon-operation-redo.svg": 959,
	"./icon-operation-undo.svg": 960,
	"./icon-page-controls.svg": 961,
	"./icon-page-insertion-insert.svg": 962,
	"./icon-page-manipulation-extract.svg": 963,
	"./icon-page-move-down.svg": 964,
	"./icon-page-move-left.svg": 965,
	"./icon-page-move-right.svg": 966,
	"./icon-page-move-up.svg": 967,
	"./icon-page-replacement.svg": 968,
	"./icon-panel-outlines.svg": 969,
	"./icon-panel-thumbnail-line.svg": 970,
	"./icon-paste-without-formatting.svg": 971,
	"./icon-paste.svg": 972,
	"./icon-pdf-portfolio.svg": 973,
	"./icon-pencil-line.svg": 974,
	"./icon-plus-sign.svg": 975,
	"./icon-portfolio-file.svg": 976,
	"./icon-portfolio-folder.svg": 977,
	"./icon-post-reply.svg": 978,
	"./icon-redact-panel.svg": 979,
	"./icon-save.svg": 980,
	"./icon-signature-plus-disabled.svg": 981,
	"./icon-signature-plus-sign.svg": 982,
	"./icon-style-panel-toggle.svg": 983,
	"./icon-sync.svg": 984,
	"./icon-text-bold.svg": 985,
	"./icon-text-italic.svg": 986,
	"./icon-text-justify-center.svg": 987,
	"./icon-text-redaction.svg": 988,
	"./icon-text-underline.svg": 989,
	"./icon-thumbtack.svg": 990,
	"./icon-tool-arc.svg": 991,
	"./icon-tool-callout-line.svg": 992,
	"./icon-tool-changeview.svg": 993,
	"./icon-tool-check-stamp.svg": 994,
	"./icon-tool-comment-line.svg": 995,
	"./icon-tool-cross-stamp.svg": 996,
	"./icon-tool-dot-stamp.svg": 997,
	"./icon-tool-fill-and-sign-calendar.svg": 998,
	"./icon-tool-highlight.svg": 999,
	"./icon-tool-image-line.svg": 1000,
	"./icon-tool-link.svg": 1001,
	"./icon-tool-measurement-arc.svg": 1002,
	"./icon-tool-measurement-area-ellipse-line.svg": 1003,
	"./icon-tool-measurement-area-line.svg": 1004,
	"./icon-tool-measurement-area-polygon-line.svg": 1005,
	"./icon-tool-measurement-cloud-area-line.svg": 1006,
	"./icon-tool-measurement-distance-line.svg": 1007,
	"./icon-tool-measurement-perimeter.svg": 1008,
	"./icon-tool-model3d.svg": 1009,
	"./icon-tool-more.svg": 1010,
	"./icon-tool-page-redact.svg": 1011,
	"./icon-tool-pen-highlight.svg": 1012,
	"./icon-tool-pen-line.svg": 1013,
	"./icon-tool-redaction-area.svg": 1014,
	"./icon-tool-select-area-redaction.svg": 1015,
	"./icon-tool-select-pages.svg": 1016,
	"./icon-tool-shape-arrow.svg": 1017,
	"./icon-tool-shape-cloud.svg": 1018,
	"./icon-tool-shape-line.svg": 1019,
	"./icon-tool-shape-oval.svg": 1020,
	"./icon-tool-shape-polygon.svg": 1021,
	"./icon-tool-shape-polyline.svg": 1022,
	"./icon-tool-shape-rectangle.svg": 1023,
	"./icon-tool-signature.svg": 1024,
	"./icon-tool-stamp-line.svg": 1025,
	"./icon-tool-text-free-text.svg": 1026,
	"./icon-tool-text-manipulation-highlight.svg": 1027,
	"./icon-tool-text-manipulation-squiggly.svg": 1028,
	"./icon-tool-text-manipulation-strikethrough.svg": 1029,
	"./icon-tool-text-manipulation-underline.svg": 1030,
	"./icon-tool-unlink.svg": 1031,
	"./icon-tools-more-active.svg": 1032,
	"./icon-tools-more-vertical.svg": 1033,
	"./icon-tools-more.svg": 1034,
	"./icon-unposted-comment.svg": 1035,
	"./icon-view-ribbon.svg": 1036,
	"./icon-view.svg": 1037,
	"./icon-watermark-panel.svg": 1038,
	"./icon-zoom-thumb-in.svg": 1039,
	"./icon-zoom-thumb-out.svg": 1040,
	"./illustration - empty state - outlines.svg": 1041,
	"./multi select.svg": 1042,
	"./redact-icons-credit-card.svg": 1043,
	"./redact-icons-email.svg": 1044,
	"./redact-icons-image.svg": 1045,
	"./redact-icons-phone-number.svg": 1046,
	"./style-panel-no-tool-selected.svg": 1047,
	"./textselect_cursor.svg": 1048,
	"./ungroup-annotations-icon.svg": 1049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;